
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookings/[status]",
      function () {
        return require("private-next-pages/bookings/[status].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookings/[status]"])
      });
    }
  